module.exports = __webpack_public_path__ + "pnskfsquadron/img/book-weapon3.png?fc34f667";